import React from "react";
import Context from "../../Context";
import Datetime from "react-datetime";
import Select from "react-select";
import DocumentPicker from "./DocumentPicker";
import { getKeysByCriteria } from "../Layout/Workdoc/typedoc";
import SuperSelect from "./SuperSelect";
import JsonformNested from "./JsonformNested";

export default class Jsonform extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      documentsCache: {},
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.formData) !== JSON.stringify(this.props.formData)
    ) {
      this.init();
    }
  }

  init = () => {
    this.setState({ formData: this.props.formData || {} });
  };

  renderInput = (field = {}) => {
    if (!field.key) {
      return (
        <span className="text-danger">Ошибка в форме. Отсутствует ключ</span>
      );
    }

    let value = this.state.formData[field.key];
    if (field.parentKey) {
      value = this.state.formData[field.parentKey]?.[field.rowIndex]?.[
        field.key
      ];
    }

    //timestamp, uuid, string, integer, double, boolean
    if (field.type === "string") {
      return (
        <input
          className="form-control"
          type="text"
          id={field.key}
          value={value || ""}
          onChange={(e) => this.onChange(field, e.target.value)}
        />
      );
    }
    if (field.type === "integer") {
      return (
        <input
          className="form-control"
          min="-2147483648"
          max="2147483648"
          step="1"
          type="number"
          id={field.key}
          value={value || ""}
          onChange={(e) => this.onChange(field, e.target.value)}
        />
      );
    }
    if (field.type === "double") {
      return (
        <input
          className="form-control"
          step="0.01"
          type="number"
          id={field.key}
          value={value || ""}
          onChange={(e) => this.onChange(field, e.target.value)}
        />
      );
    }
    if (field.type === "boolean") {
      return (
        <input
          type="checkbox"
          id={field.key}
          onChange={(e) => this.onChange(field, e.target.checked)}
          checked={value ? true : false}
        />
      );
    }
    if (field.type === "timestamp") {
      return (
        <>
          <Datetime
            value={value ? new Date(value) : ""}
            onChange={(v) => this.dateTimeChange(field, v)}
          />
        </>
      );
    }
    if (field.type === "select") {
      let items = field.data || [];
      return (
        <Select
          value={this.context.api.getReferenceValue(value, items)}
          onChange={(v) => this.selectChange(field, v)}
          className="from-control react-select"
          classNamePrefix="react-select-inner"
          options={items}
          placeholder={""}
          noOptionsMessage={() => ""}
          isClearable
          isMulti={field.multiple ? true : false}
        />
      );
    }
    if (field.type === "reference") {
      if (field.value) {
        return (
          <SuperSelect
            add
            async
            reclimit={50}
            defaultValue={value}
            onChange={(v) => this.onChange(field, v)}
            essence={field.value}
            placeholder={""}
            nameField="label"
            idField="label"
            isClearable
          />
        );
      } else {
        return (
          <div className="text-muted text-small py-2">Не указан справочник</div>
        );
      }
    }
    if (field.type === "document") {
      return (
        <DocumentPicker
          classes={getKeysByCriteria("inWorkdoc")}
          states={["disabled"]}
          defaultValue={value}
          onChange={(documentid, document) =>
            this.onDocumentChange(field, documentid, document)
          }
        />
      );
    }
  };

  selectChange = (field, result) => {
    let value = null;
    if (Array.isArray(result)) {
      let arValues = [];
      result.forEach((resultItem) => arValues.push(resultItem.value));
      value = arValues;
    } else {
      value = result ? result.value : null;
    }
    this.onChange(field, value);
  };

  dateTimeChange = (field, value) => {
    if (value instanceof Object) {
      this.onChange(field, value.toDate());
    }
  };

  onChange = (field, value) => {
    let { key, parentKey } = field;
    this.setState(
      (state) => {
        let { formData } = state;
        if (parentKey) {
          if (!formData[parentKey]) {
            formData[parentKey] = [];
          }
          if (!formData[parentKey][field.rowIndex]) {
            formData[parentKey][field.rowIndex] = {};
          }
          formData[parentKey][field.rowIndex][key] = value;
        } else {
          formData[key] = value;
        }

        return { formData };
      },
      () => {
        if (field.mutable) {
          if (this.props.onMutate) {
            this.props.onMutate(this.state.formData);
          }
        }
        if (this.props.onChange) {
          this.props.onChange(this.state.formData);
        }
      }
    );
  };

  onDocumentChange = (field, documentid, document) => {
    this.setState(
      (state) => {
        let { documentsCache } = state;
        documentsCache[documentid] = document;
        return { documentsCache };
      },
      () => this.onChange(field, documentid)
    );
  };

  nestedRowDown = (idx, key) => {
    this.setState((state) => {
      let { formData } = state;
      if (Array.isArray(formData[key])) {
        formData[key].splice(
          idx,
          2,
          formData[key][idx + 1] || {},
          formData[key][idx]
        );
        return { formData };
      }
    });
  };

  nestedRowUp = (idx, key) => {
    if (idx > 0) {
      this.setState((state) => {
        let { formData } = state;
        if (Array.isArray(formData[key])) {
          formData[key].splice(
            idx - 1,
            2,
            formData[key][idx],
            formData[key][idx - 1]
          );

          return { formData };
        }
      });
    }
  };

  nestedRowRemove = (idx, key) => {
    this.setState((state) => {
      let { formData } = state;
      if (Array.isArray(formData[key])) {
        formData[key].splice(idx, 1);

        return { formData };
      }
    });
  };

  nestedRowAdd = (idx, key) => {
    this.setState((state) => {
      let { formData } = state;
      if (Array.isArray(formData[key])) {
        formData[key].splice(idx || 0, 0, {});
      } else {
        formData[key] = [{}];
      }
      return { formData };
    });
  };

  render() {
    const renderRow = (field) => {
      if (field.type === "subform") {
        return (
          <div className="modal-inlet">
            <h6>{field.label}</h6>
            <JsonformNested
              field={field}
              formData={this.state.formData || {}}
              renderInput={this.renderInput}
              rowDown={this.nestedRowDown}
              rowUp={this.nestedRowUp}
              rowRemove={this.nestedRowRemove}
              rowAdd={this.nestedRowAdd}
            />
          </div>
        );
      } else {
        return (
          <div className="row mb-3 align-items-center">
            <div className="col-lg-3">{field.label}</div>
            <div className="col">{this.renderInput(field)}</div>
          </div>
        );
      }
    };
    return (
      <>
        {(this.props.fields || []).map((field, idx) => {
          return <div key={idx}>{renderRow(field)}</div>;
        })}
      </>
    );
  }
}
